import { Locale } from '@cars4ever/public-ui';

import IFieldConfig from '../types/IFieldConfig';

import { plateNumberMask } from './masksConfigMap';

export const unmask = (value: string): string => value.replace(/\s/g, '');

const plateNumberConfigMap: Record<Locale, IFieldConfig> = {
  [Locale.DK]: {
    inputProps: {
      mask: plateNumberMask as never,
    },
    validate: (value: string): boolean => /^[A-Za-z0-9]{2,7}$/.test(value),
  },
  [Locale.SE]: {
    inputProps: {
      mask: plateNumberMask as never,
    },
    validate: (value: string): boolean => /^[A-Za-z0-9]{2,8}$/.test(value),
  },
};

export default plateNumberConfigMap;
